import React from 'react'
import { getCWPEnvironmentForURL, APIENDPOINT } from '../../utils/common-utils'

const buildNavButton = (item, onClick, className = '') => {
  if (item.Link && item.Link[0].string !== '') {
    const env = getCWPEnvironmentForURL(window.location.href)
    const url = `${APIENDPOINT(env).base}${item.Link[0].string}`
    return (
      <a
        className={`Button Button--primary ${className} ${
          item.classes && item.classes.map(customClasses => customClasses).join(' ')
        }`}
        href={url}
        target={item.target}
        rel='noopener noreferrer'
        data-analytics={item.dataAnalytics}>
        {item.text}
      </a>
    )
  } else {
    return (
      <button
        className={`Button Button--primary ${className} ${
          item.classes && item.classes.map(customClasses => customClasses).join(' ')
        }`}
        onClick={() => onClick(item.classes)}
        target={item.target}
        rel='noopener noreferrer'
        data-analytics={item.dataAnalytics}>
        {item.text}
      </button>
    )
  }
}

export const buildNavItems = (navItems, onClick) => {
  return (
    <>
      {navItems.map((item, index) => {
        return (
          <div className='ms-listItem' key={`menu-item-${index.toString()}`}>
            <p>
              {(item.linkType === '' || item.linkType === 'default') && (
                <a
                  className={`Link Link--currentColor u-padding4 ${
                    item.classes && item.classes.map(customClasses => customClasses).join(' ')
                  }`}
                  href={item.Link ? item.Link[0].string : '#'}
                  target={item.target}
                  rel='noopener noreferrer'
                  data-analytics={item.dataAnalytics}>
                  {item.icon === 'secure' && (
                    <i className='Icon icon-shield u-marginRight4' aria-hidden='true'></i>
                  )}
                  {item.text}
                </a>
              )}
              {item.linkType === 'phone' && (
                <a
                  className={`Link Link--currentColor u-padding4`}
                  href={item.Link ? `tel:${item.Link[0].string}` : '#'}
                  target={item.target}
                  rel='noopener noreferrer'
                  data-analytics={item.dataAnalytics}>
                  {item.icon === 'phone' && (
                    <i>
                      <span
                        aria-hidden='true'
                        className='Icon u-textSizeMsrp1 u-alignMiddle u-marginRight4'>
                        &#xe0cd;
                      </span>
                      <span className='u-hiddenVisually'>Phone number</span>
                    </i>
                  )}
                  {item.text}
                </a>
              )}
              {item.linkType === 'primary-button-white' &&
                buildNavButton(item, onClick, 'u-bgColorWhite u-textColorDefault')}
              {item.linkType === 'primary-button-blue' && buildNavButton(item, onClick)}
              {index + 1 !== navItems.length && (
                <span
                  className='u-textColorWhite u-marginHoriz8'
                  key={`menu-item-pipe-${index.toString()}`}>
                  |
                </span>
              )}
            </p>
          </div>
        )
      })}
    </>
  )
}
